module.exports = __webpack_public_path__ + "media/share_images/bells-0c0f9ab4.svg";